import Hero from "./Hero/Hero";
import HeadQuarters from "./HeadQuarters/HeadQuarters";

function Content({ heroRef, headQuartersRef }) {
  return (
    <main class="main-landing">
      <Hero heroRef={heroRef} />
      <HeadQuarters headQuartersRef={headQuartersRef} />
    </main>
  );
}

export default Content;
